var _linearGradient, _clipPath, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlatformWindows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 619,
    viewBox: "0 0 619 619",
    width: 619,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 13.929,
    x2: 605.386,
    y1: 605.265,
    y2: 13.8068
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#623079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6784,
    stopColor: "#8b44ac"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m147.9 124.667h323.996v371.394h-323.996z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m539.777 619h3.711c38.715 0 70.522-28.997 74.976-66.508l.536-251.295c-4.401-167.094-141.26-301.197-309.445-301.197-170.963 0-309.555 138.568-309.555 309.5 0 169.103 135.642 306.578 304.077 309.5z",
    fill: "url(#a)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m147.9 192.635 132.781-18.353v128.683h-132.781zm0 235.457 132.781 18.353v-127.087h-132.781zm147.389 20.311 176.607 24.445v-153.49h-176.607zm0-276.079v130.641h176.607v-155.086z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlatformWindows);
export default __webpack_public_path__ + "static/media/platform-windows.dc1519c833434cb4044184479b84eba6.svg";
export { ForwardRef as ReactComponent };